<template>
    <v-form>
        <v-row>
            <v-col cols="12">
                <v-text-field
                    v-model="form.code"
                    outlined
                    dense
                    clearable
                    hide-details="auto"
                    label="Code">
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.from"
                    outlined
                    dense
                    hide
                    clearable
                    label="From">
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <PDatePicker
                    v-model="form.to"
                    outlined
                    dense
                    clearable
                    hide
                    label="To">
                </PDatePicker>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-text-field
                    v-model="form.purchase_order_code"
                    outlined
                    clearable
                    dense
                    hide-details="auto"
                    label="Purchase Order">
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import PDatePicker from "./../../components/common/PDatePicker"
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "GoodReceiptListSearch",
    components: {
        PDatePicker
    },
    data() {
        return {
            form: {
                code: null,
                from : null,
                to : null,
                purchase_order_code: null
            }
        }
    },
    computed: {
        ...mapGetters({
            params: "purchase/goodReceipt/params"
        })
    },
    methods: {
        ...mapActions({
            updateParams: "purchase/goodReceipt/updateParams"
        }),
        submit() {
            this.updateParams(this.form)
        }
    },
      created() {
        this.form = {...this.params}
    }
}
</script>

<style>

</style>